<template>
  <ais-numeric-menu :attribute="attribute" :items="options" >
    <div class="mb-4" :data-refinement="attribute" :data-url-label="urlParam" slot-scope="{ items, refine, createURL }">
      <div v-if="items.length" class="small text-uppercase font-weight-bold mb-2">
        {{ title }}
      </div>
      <d-button  v-for="(item, idx) in items" :key="`${urlParam}-${item.label}`"
        :href="createURL(item.value)"
        @click.prevent="refine(item.value)"
        pill outline class="pt-1 pb-1 mb-1 mr-1 text-left" 
        :class="{active: item.isRefined, 'btn-block': btnBlock}">
      {{ item.label }}
      </d-button>
    </div>
</ais-numeric-menu>

</template>
<script>
export default {
  name: 'Filters',
  props: {

    title: {
      type: String,
      default: '',
    },
    urlParam: {
      type: String,
      default: '',
    },
    btnBlock: {
      type: Boolean,
      default: false,
    },
    attribute: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default() {
        return [];
      },
    },
  },
};

</script>
